import { inject, Injectable } from '@angular/core';
import { MsgBoxType, UiCustomToastComponent } from '@ui';
import { ToastrService } from 'ngx-toastr';
import { ViewportService } from './viewport.service';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private latestToastId: number | undefined;
  private readonly viewport = inject(ViewportService);

  constructor(private toastService: ToastrService) {}

  public showCustomAlert(message: string, type: MsgBoxType): void {
    const customToast = this.toastService.show(message, undefined, {
      closeButton: true,
      disableTimeOut: true,
      toastComponent: UiCustomToastComponent,
      positionClass: this.viewport.isMobile()
        ? 'toast-mobile-floating'
        : 'toast-bottom-center-custom',
    });
    if (this.latestToastId) {
      this.toastService.remove(this.latestToastId);
    }
    const instance = customToast.toastRef
      .componentInstance as UiCustomToastComponent;

    instance.alertType = type;
    instance.title = undefined;
    instance.message = message;
    instance.toastId = customToast.toastId;
    this.latestToastId = customToast.toastId;
  }
}
